import template from './session-notification.html';
import controller from './session-notification.controller';
import './session-notification.styl';

let sessionNotificationComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default sessionNotificationComponent;



// WEBPACK FOOTER //
// ./client/app/common/session-notification/session-notification.component.js